// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// React icons
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

function FaqCollapse({ title, open, children, ...rest }) {

  return (
    <VuiBox mb={1.5} sx={{ background: "#ffffff", boxShadow: '0 0 59px 0 rgb(28 137 212 / 10%)', borderRadius: '5px' }}>
      <VuiBox
        {...rest}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pt={'12px'}
        pr={'20px'}
        pb={'12px'}
        pl={'20px'}
        sx={{ cursor: "pointer" }}
      >
        <VuiTypography variant="h5" color="#06192d" sx={{ userSelect: "none" }}>
          {title}
        </VuiTypography>
        <VuiBox color="dark" lineHeight={0}>
          {open ? <IoIosArrowUp color="brand" /> : <IoIosArrowDown color="dark" />}
        </VuiBox>
      </VuiBox>
      <Collapse timeout={400} in={open}>
        <VuiBox pt={'5px'} pr={'20px'} pb={'20px'} pl={'20px'} lineHeight={1}>
          <VuiTypography variant="button" color="text" fontWeight="regular" fontFamily="Nunito" fontSize="16px" lineHeight="24px">
            {children}
          </VuiTypography>
        </VuiBox>
      </Collapse>
    </VuiBox>
  );
}

// Typechecking props for the FaqCollapse
FaqCollapse.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default FaqCollapse;
